import React from "react"
import {Drawer, Form, Row, Col, Select, Button, Switch, InputNumber} from "antd"
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {compose} from "recompose";
import { sortBy } from 'lodash';
import * as SelectionActions from "../../reducers/selection_builder";
import {withRouter} from "react-router";
import selection from "../../reducers/selection";

const {Option} = Select;

function readUrl(i) {
    var path = i.split("/");
    var pg_url = path[path.length - 2]
    return pg_url
};

class CreationGroupDrawer extends React.Component {

    static propTypes = {
        insertGroup: PropTypes.func.isRequired
    };


    onSubmit = (e) => {
        e.preventDefault();
        const {match} = this.props;
        const urlId = match.params.id;
        var groupId = readUrl(window.location.pathname);
        this.props.form.validateFields((errors, values) => {
            if (!errors) {
                this.props.insertGroup(values, urlId, groupId);
                this.props.toggleVisibility()

            }
        });
    };



    render() {

        const {visible, toggleVisibility, populate, form: {getFieldDecorator}} = this.props;
        return <Drawer title="Create a new group item" width={720} placement="right" visible={visible} style={{
            height: 'calc(100% - 55px)',
            overflow: 'auto',
            paddingBottom: 53,
        }} onClose={toggleVisibility}>
            <Form onSubmit={this.onSubmit}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Education">
                            {getFieldDecorator('education', {
                                rules: [{required: false, message: 'Please select a Education'}],
                            })(
                                <Select allowClear={true}
                                        placeholder="Education"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                    {sortBy(populate.education, ['label_s']).map((user) => (
                                        <Option value={user.code}>{user.label_s} {user.status === '0' ? '(Inactive)' : ''}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Person Type">
                            {getFieldDecorator('persType', {
                                rules: [{required: false, message: 'Please select a Person Type'}],
                            })(
                                <Select allowClear={true}
                                        placeholder="Person Type"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                    {sortBy(populate.persType, ['label_s']).map((user) => (
                                        <Option value={user.code}>{user.label_s} {user.status === '0' ? '(Inactive)' : ''}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Person Super Speciality">
                            {getFieldDecorator('persSuperSpc', {
                                rules: [{required: false, message: 'Please select a Person Super Speciality'}],
                            })(
                                <Select allowClear={true}
                                        placeholder="Person Super Speciality"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                    {sortBy(populate.persSuperSpc, ['label_s']).map((user) => (
                                        <Option value={user.code}>{user.label_s} {user.status === '0' ? '(Inactive)' : ''}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Person Speciality">
                            {getFieldDecorator('persSpc', {
                                rules: [{required: false, message: 'Please select a Person Speciality'}],
                            })(
                                <Select allowClear={true}
                                        placeholder="Person Speciality"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                    {sortBy(populate.persSpc, ['label_s']).map((user) => (
                                        <Option value={user.code}>{user.label_s} {user.status === '0' ? '(Inactive)' : ''}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Site Type">
                            {getFieldDecorator('siteType', {
                                rules: [{required: false, message: 'Please select a Site Type'}],
                            })(
                                <Select allowClear={true}
                                        placeholder="Site type"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                    {sortBy(populate.siteType, ['label_s']).map((user) => (
                                        <Option value={user.code}>{user.label_s} {user.status === '0' ? '(Inactive)' : ''}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Position">
                            {getFieldDecorator('posistion', {
                                rules: [{required: false, message: 'Please select a Position'}],
                            })(
                                <Select allowClear={true}
                                        placeholder="Position"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                    {sortBy(populate.posistion, ['label_s']).map((user) => (
                                        <Option value={user.code}>{user.label_s} {user.status === '0' ? '(Inactive)' : ''}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Working Speciality">
                            {getFieldDecorator('workingSpec', {
                                rules: [{required: false, message: 'Please select a Working Speciality'}],
                            })(
                                <Select allowClear={true}
                                        placeholder="Working Speciality"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                    {sortBy(populate.workingSpec, ['label_s']).map((user) => (
                                        <Option value={user.code}>{user.label_s} {user.status === '0' ? '(Inactive)' : ''}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Site Speciality">
                            {getFieldDecorator('siteSpec', {
                                rules: [{required: false, message: 'Please select a Site Speciality'}],
                            })(
                                <Select allowClear={true}
                                        placeholder="Site Speciality"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                    {sortBy(populate.siteSpec, ['label_s']).map((user) => (
                                        <Option value={user.code}>{user.label_s} {user.status === '0' ? '(Inactive)' : ''}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                <Col span={12}>
                    <Form.Item label="Private/Public Sector Type">
                        {getFieldDecorator('sectorType', {
                            rules: [{required: false, message: 'Please select a Sector Type'}],
                        })(
                            <Select allowClear={true}
                                    placeholder="Sector Type"
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        || option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }>
                                {sortBy(populate.sectorType, ['label_s']).map((user) => (
                                    <Option value={user.code}>{user.label_s} {user.status === '0' ? '(Inactive)' : ''}</Option>
                                ))}
                            </Select>
                        )}
                    </Form.Item>
                </Col>
            </Row>
                <Row gutter={16}>
                    <Col span={6}>
                        <Form.Item label="Postal Range Begin">
                            {getFieldDecorator('siteZipFrom', {
                                rules: [{required: false, message: 'Please specify an postal code range start'}],
                            })(
                                <InputNumber placeholder="Range begin">
                                </InputNumber>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Postal Range End">
                            {getFieldDecorator('siteZipTo', {
                                rules: [{required: false, message: 'Please specify an postal code range end'}],
                            })(
                                <InputNumber placeholder="Range end">
                                </InputNumber>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Site aPureBase ID">
                            {getFieldDecorator('parentSiteApurebaseId', {
                                rules: [{required: false, message: 'Please specify a site aPureBase ID'}],
                            })(
                                <InputNumber style={{width:'100%'}} placeholder="Site aPureBase ID">
                                </InputNumber>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item label="Active">
                            {getFieldDecorator('status', {
                                valuePropName: 'checked',
                                initialValue: true
                            })(
                                <Switch/>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Site Selection">
                            {getFieldDecorator('isSiteSelection', {
                                valuePropName: 'checked',
                                initialValue: false
                            })(
                                <Switch/>
                            )}
                        </Form.Item>
                    </Col>
                </Row>

                <div
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e8e8e8',
                        padding: '10px 16px',
                        textAlign: 'right',
                        left: 0,
                        background: '#fff',
                        borderRadius: '0 0 4px 4px',
                    }}
                >
                    <Button
                        style={{
                            marginRight: 8,
                        }}
                        onClick={toggleVisibility}
                    >
                        Cancel
                    </Button>
                    <Button onClick={this.onSubmit} type="primary">Submit</Button>
                </div>
            </Form>
        </Drawer>
    }

}

const mapStateToProps = state => ({
    overview: state.selection_builder.overview,
    overviewLoader: state.selection_builder.overviewLoader
});

const mapDispatchToProps = dispatch => ({
    insertGroup: bindActionCreators(SelectionActions, dispatch).insertGroupSelections,
});

export default compose(
    withRouter,
    Form.create(),
    connect(mapStateToProps, mapDispatchToProps),
)(CreationGroupDrawer);



// WEBPACK FOOTER //
// ./src/js/selection/create/CreationGroupDrawer.js